import {EventType} from "../../../../gd/const/event"
import {calendar_getTaskEventProjectId} from "./get-task-event-project-id"

// const debug = "calendar_createTaskEvent"
const debug = false

// scopeProjectIds - projects the calendar shows (with sub folders), picks the shown project of a linked task
export default function calendar_createTaskEvent(data: any, type: EventType, scopeProjectIds?: ID[]) {
    const event: any = {
        id                  : 'task_' + data.id,
        // userId              : data.assignedToUserId,
        assignedToUserId    : data.assignedToUserId,
        name                : data.title,
        projectId           : calendar_getTaskEventProjectId(data, scopeProjectIds),
        isAccomplished      : gd.const.systemStatus.isClosed(data.systemStatus),
        type                : type,
        task                : data,
        tags                : data.tags,
    }

    switch (type) {
        case EventType.TASK_DEADLINE:
            event.startDate = data.deadline
            break

        case EventType.TASK_SCHEDULE:
            event.startDate = data.scheduleDate
            break

        case EventType.TASK_START_END:
            event.startDate = data.startDate
            event.endDate = data.endDate
            break
    }

    return event
}